import echarts from "echarts";
import { i18n } from "../../../language";
import store from "../../../store/";

let isDarkMode = () => store.state.user.darkMode;

var labelOption = {
    show: true,
    position: "inside",
    /*distance: 15,*/
    /*align: "left",*/
    verticalAlign: "middle",
    rotate: 0,
    /*formatter: "{name|{a}}({c})",*/
    formatter: "{c}",
    fontSize: 11,
    rich: {
        name: {
            textBorderColor: "#fff",
        },
    },
};

function subFormatter(value) {
    let date = value[0].axisValue;
    let items = value.map((x) => x.marker + " " + x.seriesName + ": " + (x.data || 0)).join("<br>");
    let totalBarValue = _.sum(value.map((x) => x.data));
    return `${date} <br> ${i18n.t("report.totalBar")}: ${totalBarValue} <br> ${items}`;
}

const colors = ["#c0c0c0", "#ee7942", "#1874cd", "#cdad00", "#9bcd9b", "#b2dfee", "#a2b5cd", "#1c86ee"];
const gradients = colors.map(
    (color) =>
        new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
                offset: 0,
                color,
            },
            {
                offset: 1,
                color: "#ffe",
            },
        ])
);
const symbols = ["circle", "rect", "roundRect", "triangle", "diamond", "pin", "arrow"];
export default function getData(data, series, max) {
    /*let max = _.max(Object.keys(series).map(x => series[x])
        .map(xs => _.max(xs)))*/

    max = max ? max + (20 - ((max + 20) % 20)) : 100;

    return {
        /*title: {
            text: i18n.tc('message.statsByTime')
        },*/
        legend: {
            show: true,
            data: Object.keys(series),
            textStyle: {
                color: isDarkMode() ? "white" : "black",
            },
        },
        responsive: true,
        maintainAspectRatio: false,
        grid: {
            left: 100,
        },
        color: ["#003366", "#006699", "#4cabce", "#e5323e"],
        toolbox: {
            feature: {
                saveAsImage: {
                    pixelRatio: 2,
                    title: "Save",
                },
            },
        },
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },
            formatter: subFormatter,
        },
        xAxis: {
            type: "category",
            /*axisTick: {show: false},*/
            axisLabel: {
                rotate: 45,
                color: isDarkMode() ? "white" : "black",
            },
            data,
        },
        yAxis: {
            type: "value",
            scale: true,
            splitNumber: 8,
            max,
            //min: 0,
            /*type: "log",*/
            logBase: 5,
            min: 0,
            axisLabel: {
                color: isDarkMode() ? "white" : "black",
            },
        },

        series: Object.keys(series).map((name, i) => {
            const color = colors[i % colors.length];

            return {
                name,
                type: "bar",
                /*step: true,*/
                stack: "a",
                symbol: symbols[i % symbols.length],
                symbolSize: 5,
                /*smooth: true,*/
                /*sampling: 'average',*/
                /*type: "bar",*/
                barGap: 0,
                barWidth: 30,
                /*barMinHeight: 40,*/
                label: labelOption,
                data: series[name],
                itemStyle: {
                    color: color,
                },
                /*lineStyle: {
                    color: color
                },*/
                /*areaStyle: {
                    color
                },*/
            };
        }),
    };
}

/*export default function getData(data, series) {
    return {
        legend: {
            show:true
        },

        toolbox: {
            feature: {
                saveAsImage: {
                    pixelRatio: 2
                }
            }
        },

        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow"
            }
        },
        dataset: {
            // Provide data.
            source: [
                ['Product', '2015', '2016', '2017'],
                ['Matcha Latte', ...randomize()],
                ['Milk Tea', ...randomize()],
                ['Cheese Cocoa', ...randomize()],
                ['Walnut Brownie', ...randomize()]
            ]
        },
        // Declare X axis, which is a category axis, mapping
        // to the first column by default.
        xAxis: {type: 'category'},
        // Declare Y axis, which is a value axis.
        yAxis: {},
        // Declare several series, each of them mapped to a
        // column of the dataset by default.
        series: [{type: 'bar'}, {type: 'bar'}, {type: 'bar'}]
    }
}*/

function randomize() {
    return [0, 0, 0].map((v) => {
        return Math.round(300 + Math.random() * 700) / 10;
    });
}
